import CarHireAirportVsCityChart from './CarHireAirportVsCityChart';

export default CarHireAirportVsCityChart;
